import React, { useCallback, useState } from 'react';
import { JiraIssueData } from '../../../../api/endpoints/jira';
import { CommandDispatcher } from '../../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../../concepts/objects';
import { Colors } from '../../../../ui';
import { useResolve } from '../../../Container';
import { escape } from '../../../canvas/commands/ManipulationCommands';
import { TextAlignment, TextSettings } from '../../../canvas/entities/TextConventions';
import { UIField, UIFieldProps } from '../../../canvas/entities/UIField';
import { useComponentObserver } from '../../../canvas/visualization/ComponentObserver';
import { SimpleTextFieldInput } from '../../../canvas/workspace/adapters/SimpleTextFieldInput';
import { jiraCardSetSummary } from '../AtlassianCommands';
import { useBinding } from '../BindingManager';
import { JiraCard } from '../JiraCard';
import { JiraOAuthRequired } from './JiraOAuthRequired';

export const JiraSummaryTextSettings = TextSettings.from({
    fontFamily: 'Rubik',
    fontColor: Colors.text,
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 1.25,
    textMargin: 0,
    fontStyle: 'normal',
    maxFontSize: null,
    textAlignH: TextAlignment.start,
    textAlignV: TextAlignment.start,
});


// return <>
//     {authed && <Content {...{ field, onClose }} />}
// </>;

const JiraSummaryFieldEditor = ({ active, field }: UIFieldProps) => {

    const objects = useResolve(ObjectManager);
    const dispatch = useResolve(CommandDispatcher);

    const object = field.owner.cast(JiraCard);
    useComponentObserver(object);

    const binding = useBinding<JiraIssueData>(object);
    const [initialValue] = useState(binding?.getState()?.summary ?? '');
    const [value, setValue] = useState(initialValue);

    const onChange = useCallback((nextValue: string) => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            binding.mutate({ summary: nextValue });
            object.sizeToContent();
            setValue(nextValue);
        });
    }, [field]);

    const onCommit = useCallback((finalValue: string) => {
        if (finalValue === initialValue) return;
        objects.update(u => {
            u.rolling(UIField.key(field));
            u.noop();
            dispatch(jiraCardSetSummary, [finalValue, [object.id]]);
            object.sizeToContent();
        });
    }, []);

    const onReject = () => dispatch(escape);

    return <JiraOAuthRequired onReject={onReject}>
        <SimpleTextFieldInput {...{
            active,
            field,
            settings: JiraSummaryTextSettings,
            value,
            onChange,
            onCommit,
        }} />
    </JiraOAuthRequired>;
};

export const JiraSummaryField = (owner: JiraCard): UIField => ({
    ui: JiraSummaryFieldEditor,
    name: 'summary',
    bounds: owner.layout.summary,
    owner,
});
// Object.defineProperty(field, 'value', {
//     get: () => owner.get('summary'),
//     set: (value: string) => owner.set('summary', value),
// });
